import type { ApiResponse } from './generic';

/**
 * User Type Definition
 */
export interface User {
  id: string;
  firstName: string;
  lastName: string;
  profileImage?: string | null;
  dateOfBirth: Date | undefined;
  language: Language;
  gender: Gender;
  phoneCountryCode: string | null;
  phoneNumber: string | null;
  phoneVerifiedAt: string | null;
  email: string;
  /** No email (spec 2026-10-15): cannot sign in, receives nothing. */
  hasNoEmail?: boolean;
  temporaryPasswordGeneratedAt: string;
  passwordChangedAt: string;
  createdAt: string;
  updatedAt: string;
}

/** supported languages */
export enum Language {
  EN = 'en',
  FR = 'fr',
}

/** supported genders */
export enum Gender {
  MALE = 'male',
  FEMALE = 'female',
  OTHER = 'other',
  PREFER_NOT_TO_SAY = 'prefer_not_to_say',
}

export type ProfileResponse = ApiResponse<User>;
